/**
 * Base URL for the backend API.
 *
 * In production this is set via REACT_APP_API_URL (e.g. the public origin
 * served behind the nginx reverse proxy, https://fleet-os.dgcars.cloud).
 * Falls back to the local backend for development.
 */
const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";

export default API_BASE_URL;
